<template>
  <v-btn
    v-bind="$attrs"
    outlined
    depressed
    dark
    :height="height"
    class="secondary"
    @click="$emit('click')"
  >
    <v-icon left>mdi-plus</v-icon>
    <slot></slot>
  </v-btn>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    height: {
      type: String,
      default: "40px",
    },
  },
};
</script>

<style></style>
